import {
  LBAzureIcon,
  LBBitbucketIcon,
  LBGithubIcon,
  LBGitlabIcon,
  LBGoogleIcon,
  LBSlackIcon
} from '@linearb/buzz';
import pick from 'lodash/pick';

export const OAuthProviders = {
  google: {
    logo: LBGoogleIcon,
    authIdentity: 'google',
    title: 'google',
    isLogin: true
  },
  github: {
    logo: LBGithubIcon,
    authIdentity: 'github',
    title: 'github',
    isLogin: true
  },
  slack: {
    logo: LBSlackIcon,
    authIdentity: 'slack',
    title: 'slack',
    isLogin: true
  },
  bitbucket: {
    logo: LBBitbucketIcon,
    authIdentity: 'bitbucket',
    title: 'bitbucket',
    isLogin: true
  },
  gitlab: {
    logo: LBGitlabIcon,
    authIdentity: 'gitlab',
    title: 'gitlab',
    isLogin: true
  },
  azure_devops: {
    authIdentity: 'azure',
    title: 'azure',
    isLogin: true,
    logo: LBAzureIcon
  }
};

export const registerProvidersTeam = () =>
  pick(OAuthProviders, ['github', 'bitbucket', 'gitlab', 'azure_devops']);

export const registerProvidersPaid = () =>
  pick(OAuthProviders, [
    'google',
    'github',
    'slack',
    'bitbucket',
    'gitlab',
    'azure_devops'
  ]);
